import { createFileRoute } from "@tanstack/react-router";
import { buildRouteHead } from "@/lib/seo/routeHead";
import EuReadinessCardiologyEs from "@/pages/EuReadinessCardiologyEs";

export const Route = createFileRoute("/es/eu-readiness-cardiology")({
  head: () => buildRouteHead("/es/eu-readiness-cardiology"),
  component: EuReadinessCardiologyEs,
});

